import { AVIS_VISUALITZACIO_OBTENIR_ULTIMA_DATA_RADAR, AVIS_INICIALITZAR } from '../../../actions/actionTypes';

const ESTAT_INICIAL = null;

const dataUltimaTileGeneradaRadar = (state = ESTAT_INICIAL, action) => {
    switch(action.type) {
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_VISUALITZACIO_OBTENIR_ULTIMA_DATA_RADAR:
            return action.dataUltimaTileGeneradaRadar;

        default:
            return state;
    }
};

export default dataUltimaTileGeneradaRadar;


// WEBPACK FOOTER //
// ./src/reducers/avis/visualitzacio/dataUltimaTileGeneradaRadar.js